import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Image from "next/image";

export default function Testimonialcard({ avatar, name,date, role, review,rating }) {
  const mainTab = useSelector((state) => state.mainTab.mainTab);
  const isCompanyCheck = mainTab === "شركات";
  return (
    <Box
      sx={{
        width: { xs: "220px", sm: "380px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        textAlign: "center",
        fontSize: "16px",
        fontWeight: "300",
        color: "#040921",
        borderRadius: "32px",
        boxShadow:
          "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
        padding: "24px",
        overflow: "hidden",
        bgcolor: "#fff",
      }}
    >
      <Image
        quality={100}
        alt="testimonials"
        src={avatar}
        width={60}
        height={60}
        style={{ height: "60px", width: "60px", borderRadius: "50%" }}
      />
      <Box sx={{ fontWeight: "600" }}>{name}</Box>
<Box sx={{ fontSize: "12px" }}>
 {date}
</Box>
      <Box
        sx={{
          height: isCompanyCheck ? { xs: "50px", sm: "45px" } : "initial",
          fontSize: { xs: "14px", sm: "initial" },
        }}
      >
        {role}
      </Box>
      <Image
        quality={100}
        width={60}
        height={10}
        alt="divider"
        src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/divider.svg"
      />
      <Box sx={{ fontSize: "14px", color: "#555", textAlign: "center" }}>
  {review}
</Box>
      <Box
        sx={{
          height: isCompanyCheck
            ? { xs: "300px", sm: "200px" }
            : { xs: "90px", sm: "60px" },

          fontSize: { xs: "14px", sm: "initial" },
        }}
      >
        {rating}
      </Box>

      <Image
        quality={100}
        width={40}
        height={40}
        alt="comma"
        src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/comma.webp"
      />

      <Image
        quality={100}
        width={105}
        height={5}
        alt="border"
        src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/border.webp"
        style={{ position: "relative", top: "24px", width: "105%" }}
      />
    </Box>
  );
}
